module.exports = __webpack_public_path__ + "img/chevron-right.787e0997.svg";